exports.install = function (Vue) {
  

  Vue.prototype.numFilter = function (options) {
    var realVal = 0
    if (options !== undefined && options !== '') {
      realVal = parseFloat(options).toFixed(2)
    }
    return realVal
  }
  // 计算图形Extent
  Vue.prototype.calcExtent = function (geos) { 
    
    let result = { Xmin: 0, Ymin: 0, Xmax: 0, Ymax: 0 }
    var xmin0 = 0
    var xmax0 = 0
    var ymin0 = 0
    var ymax0 = 0

    if (geos[0].type === 'point') {
      var arrX = []
      var arrY = []
      for (let i = 0; i < geos.length; i++) {
        arrX.push(geos[i].x)
        arrY.push(geos[i].y)
      }
      var Xmax = Math.max.apply(Math, arrX)
      var Xmin = Math.min.apply(Math, arrX)
      var Ymax = Math.max.apply(Math, arrY)
      var Ymin = Math.min.apply(Math, arrY)

      result.Xmin = Xmin
      result.Ymin = Ymin
      result.Xmax = Xmax
      result.Ymax = Ymax

      // extent = new Extent(
      //   Xmin,
      //   Ymin,
      //   Xmax,
      //   Ymax,
      //   new SpatialReference({ wkid: 4326 })
      // )
      //   .offset(0.0008, 0)
      //   .expand(2.5)
    } else {
      let ext0 = geos[0].extent
      xmin0 = ext0.xmin
      xmax0 = ext0.xmax
      ymin0 = ext0.ymin
      ymax0 = ext0.ymax
      for (var i = 0; i < geos.length; i++) {
        let ext = geos[i].extent
        var xmin = ext.xmin
        var xmax = ext.xmax
        var ymin = ext.ymin
        var ymax = ext.ymax

        xmin0 = xmin < xmin0 ? xmin : xmin0
        ymin0 = ymin < ymin0 ? ymin : ymin0
        xmax0 = xmax > xmax0 ? xmax : xmax0
        ymax0 = ymax > ymax0 ? ymax : ymax0
      }

      result.Xmin = xmin0
      result.Ymin = ymin0
      result.Xmax = xmax0
      result.Ymax = ymax0

      // extent = new Extent(
      //   xmin0,
      //   ymin0,
      //   xmax0,
      //   ymax0,
      //   new SpatialReference({ wkid: 4326 })
      // )
      //   .offset(0.0008, 0)
      //   .expand(2.5)
    }
    return result
  }

  // 计算图形面积
  Vue.prototype.calculateGeoArea = function (geo) { 
    return new Promise((resolve) => {
      // 动态导入，避免构建时报错
      import('esri-loader').then(({ loadModules }) => {

        loadModules([
          'esri/geometry/geometryEngine',
          'esri/geometry/SpatialReference',
          'esri/rest/GeometryService',
          'esri/rest/support/ProjectParameters',
        ]
        ).then(
          ([
            geometryEngine,
            SpatialReference,
            GeometryService,
            ProjectParameters
          ]) => {

            var targetSR = new SpatialReference({ wkid: 4528 })
            var pGeoArea = 0
            if (Array.isArray(geo) && geo.length > 0) {
              geo = geometryEngine.union(geo)
            }
            if (geo!==null) {
              var projectParams = new ProjectParameters()
              projectParams.geometries = [geo]
              projectParams.outSpatialReference = targetSR

              // 使用GeometryService转换坐标系
              GeometryService.project(this.WGmapConfig.geometryService, projectParams).then(function (projectedGeometries) {
                if (projectedGeometries != null && projectedGeometries.length > 0) {
                  var projectedPolygon = projectedGeometries[0]
                  if (projectedPolygon !== null) {
                    if (geo.type === 'polygon') {
                      pGeoArea = Number(geometryEngine.planarArea(projectedPolygon, 'square-meters'))
                      resolve(pGeoArea)
                    } else if (geo.type === 'polyline') {
                      pGeoArea = geometryEngine.planarLength(projectedPolygon, 'meters')
                      resolve(pGeoArea)
                    }
                  } else {
                    this.msgError('图形面积计算有误')
                  }
                }
              })

            } else {
              resolve(0)
            }
          })
      
      })

    })
      
  }
  //union图形
  Vue.prototype.geoUnion = function (geometries) {
    return new Promise((resolve) => {
      import('esri-loader').then(({ loadModules }) => {
        loadModules(['esri/geometry/geometryEngine']).then(
          ([
            geometryEngine,
          ]) => {
            var union = null
            if (geometries.length > 0) {
              union = geometryEngine.union(geometries)
            }
            resolve(union)

          })

      })
    })
  }
  
  Vue.prototype.gcj02towgs84 = function (lng, lat) {
  // 1. 强制转换为浮点数，防止输入的是字符串导致的计算错误
  lng = parseFloat(lng);
  lat = parseFloat(lat);

  // 2. 内部常量定义（确保在方法作用域内可访问）
  const PI = 3.1415926535897932384626;
  const a = 6378245.0; 
  const ee = 0.00669342162296594323;

  // 3. 辅助函数定义在内部，解决找不到方法的问题
  const transformlat = (x, y) => {
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
    return ret;
  };

  const transformlng = (x, y) => {
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
    return ret;
  };

  // 4. 边界检查
  if (lng < 72.004 || lng > 135.05 || lat < 0.8293 || lat > 55.8271) {
    return [lng, lat];
  }

  // 5. 核心计算
  let dlat = transformlat(lng - 105.0, lat - 35.0);
  let dlng = transformlng(lng - 105.0, lat - 35.0);
  let radlat = lat / 180.0 * PI;
  let magic = Math.sin(radlat);
  magic = 1 - ee * magic * magic;
  let sqrtmagic = Math.sqrt(magic);
  
  dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
  dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
  
  const mglat = lat + dlat;
  const mglng = lng + dlng;
  
  // 6. 结果纠偏并输出数组
  return [
    Number((lng * 2 - mglng).toFixed(6)), 
    Number((lat * 2 - mglat).toFixed(6))
  ]
  }
}
